const getOrderedDaysOfWeek = (weekStartsOn: WeekStartsOn): string[] => {
  switch (weekStartsOn) {
    case 'MON':
      return [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ];
    case 'TUE':
      return [
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Monday',
      ];
    case 'WED':
      return [
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
      ];
    case 'THUR':
      return [
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
      ];
    case 'FRI':
      return [
        'Friday',
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
      ];
    case 'SAT':
      return [
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
      ];
    case 'SUN':
    default:
      return [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
  }
};

export const getDayOfWeekIndex = ({
  value,
  weekStartsOn,
}: {
  value: string;
  weekStartsOn: WeekStartsOn;
}): number => {
  const lower = value.toLowerCase();
  const orderedDays = getOrderedDaysOfWeek(weekStartsOn);
  return orderedDays.findIndex(
    (d) =>
      d.toLowerCase() === lower ||
      d.substring(0, 3).toLowerCase() === lower ||
      d.substring(0, 4).toLowerCase() === lower,
  );
};

export default getOrderedDaysOfWeek;
